import 'react';
import { AvatarGroupContext } from './useAvatarContext.js';
import { jsx } from 'react/jsx-runtime';

function AvatarGroupProvider({
  variant,
  size,
  autoFixFontSize,
  maxCount,
  children
}) {
  return /*#__PURE__*/jsx(AvatarGroupContext.Provider, {
    value: {
      variant,
      size,
      autoFixFontSize,
      maxCount
    },
    children: children
  });
}

export { AvatarGroupProvider };
